import { EntityState } from '@ngrx/entity';
import { MemberType } from '../models/company.model';
import { Aircrafts, Software } from '../models/equipment.model';
import { GroundControlPoint, NoFlyZone } from '../models/geoasset.model';
import { ProjectDto } from '../models/project.model';
import { PrivilegedRole, ProfileType, UserRole } from '../models/user.model';

export enum LoadingState {
  FUTURE = 'FUTURE',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
export interface ProfileState {
  id: string;
  companyId: string;
  given_name: string;
  family_name: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  avatar: string;
  loadingState: LoadingState;
  quantumProfileLoadingState: LoadingState;
  updatedState: LoadingState;
  roleLoadingState: LoadingState;
  activeProfileError?: any;
  quantumProfileError?: any;
  completed: boolean;
  role: UserRole;
  isMasteradmin: boolean;
  /** Optional for tests. Must be always set in production. */
  privilegedRole?: PrivilegedRole | null;
  /** The masteradmin acting as this user. Only the impersonation tab reads these two. */
  impersonatedBy?: Partial<ProfileType>;
  impersonationExpiresAt?: string;
  /** Set when an impersonation ended and its user stayed: the page asks for nothing more. */
  apiFrozen?: boolean;
}

export interface CompanyState {
  id?: string;
  name: string;
  country: string;
  stateOrProvince: string;
  postalCode: string;
  industry: string;
  fieldsOfApplication?: string[];
  avatar: string;
  members: EntityState<MemberType>;
  loadingState: LoadingState;
  loadingAvatarState: LoadingState;
  updateAvatarState: LoadingState;
  updateState: LoadingState;
  creatingState: LoadingState;
  completed: boolean;
  error: any;
}

export interface EquipmentState {
  aircrafts: EntityState<Aircrafts>;
  software: EntityState<Software>;
  loadingState: LoadingState;
  updateState: LoadingState;
  completed: boolean;
  error: any;
}

export interface GroundControlPointState {
  groundControlPoints: EntityState<GroundControlPoint>;
  loadingState: LoadingState;
  updateState: LoadingState;
  completed: boolean;
  error: any;
}

export interface NoFlyZoneState {
  noFlyZones: EntityState<NoFlyZone>;
  loadingState: LoadingState;
  updateState: LoadingState;
  completed: boolean;
  error: any;
}

export interface ProjectState {
  projects: EntityState<ProjectDto>;
  loadingState: LoadingState;
  updateState: LoadingState;
  completed: boolean;
  error: any;
}
